/**
 * Takes elements from the end of an array
 */
export const takeRight = <T>(array: T[], n: number): T[] => {
  return n === 0 ? [] : array.slice(-n)
}
